import site from "../../content/data/site.json"

// Static snapshot of the WordPress theme options (previously a WPGraphQL static query)
export default function useQueryThemeOptions() {
  return { wp: site.wp }
}
